export enum ParcelType {
    UNKNOWN = 0,
    OCEAN = 10,
    NEAR_OCEAN = 20,
    INLAND = 30,
};
